import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CdkDropList } from '@angular/cdk/drag-drop';

import { WebColumnResizeComponent } from '@web/shared/components/web-column-resize/web-column-resize.component';

import { BaseSectionComponent } from '../base-section.abstract';
import { SingleHoverDirective } from '../../../directives/single-hover.directive';
import { AddButtonsComponent } from '../../add-buttons/add-buttons.component';
import { DefaultColumnComponent } from '../../columns/default-column/default-column.component';

@Component({
    selector: 'web-default-section',
    templateUrl: './default-section.component.html',
    styleUrls: ['./default-section.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslatePipe,
        CdkDropList,
        SingleHoverDirective,
        AddButtonsComponent,
        DefaultColumnComponent,
        WebColumnResizeComponent,
    ],
})
export class DefaultSectionComponent extends BaseSectionComponent {}
